const parseUrl = (position) => {
    const url = new URL(window.location.href);
    const pathName = url.pathname.split("/");
    return pathName[position];
}

export default parseUrl;